import { Attributes } from 'interfaces/attribute.interface';
import { SiteStatusCodes } from 'common/enum';
import { defaultAttribute } from 'common/static';

/**
 * Builds the initial attributes array for a new user, embedding the assigned
 * groupId into each active site's attribute entry.
 *
 * For active sites (ACT), the result includes both the default status and a
 * group-specific entry: e.g. { DB30: [{ S: "ACT" }, { "24": [{ S: "ACT" }] }] }
 *
 * For denied sites (DNY), only the default status is included.
 */
export function BuildInitialAttributes(groupId: number): Attributes[] {
  return defaultAttribute.map((attr) => {
    const appCode = Object.keys(attr)[0];
    const values = attr[appCode];
    const statusEntry = values.find((v) => Object.prototype.hasOwnProperty.call(v, 'S'));
    const statusCode = statusEntry ? (statusEntry as { S: string }).S : null;

    if (statusCode === SiteStatusCodes.ACTIVE) {
      return {
        [appCode]: [
          { S: SiteStatusCodes.ACTIVE },
          { [String(groupId)]: [{ S: SiteStatusCodes.ACTIVE }] },
        ],
      };
    }

    return attr;
  });
}
